import type { AssetDataType } from '@repo/types/asset';
import type { AssetAttachment, Attachments } from '@repo/types/attachment';

import { getAssetData } from './customer-assets.selectors';

const selectAttachmentsFn = getAssetData(
    (data) => data.assetDetails.fileAttachments,
    (data) => data.assetDetails.cartData?.attachments,
    (data) => data.assetDetails.cartData?.attachments
);

export const selectAttachments = (data?: AssetDataType) => {
    const attachments = selectAttachmentsFn(data);

    if (!attachments) {
        return [];
    }

    return normalizeData(attachments);
};

const getFileReference = (attachmentLocation?: string) => {
    return attachmentLocation?.split('/').pop();
};

const normalizeData = (attachments: Attachments): AssetAttachment[] => {
    const items = attachments.map((attachment) => {
        const { fileType, originalFileName, uploadedDate } = attachment;
        return {
            fileType,
            originalFileName,
            uploadedDate: typeof uploadedDate === 'string' ? uploadedDate : '',
            ...('fileReference' in attachment
                ? { fileReference: attachment.fileReference }
                : {
                      // fileReference is not in DtoFileAttachment, take it from attachmentLocation
                      fileReference: getFileReference(attachment.attachmentLocation),
                      attachmentComment: attachment.attachmentComment,
                  }),
            ...('attachmentLocation' in attachment ? { attachmentLocation: attachment.attachmentLocation } : {}),
        };
    });

    return items;
};
